import { render } from "./TopSection.vue?vue&type=template&id=635d65e0&scoped=true"
import script from "./TopSection.vue?vue&type=script&lang=js"
export * from "./TopSection.vue?vue&type=script&lang=js"

import "./TopSection.vue?vue&type=style&index=0&id=635d65e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Liam\\Documents\\werowebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635d65e0"]])

export default __exports__